import styled from "styled-components";

const FormLabelDescriptionTitle = styled.p`
  display: block;
  max-width: 380px;
  width: 100%;
  margin: 10px auto 20px 0px;
  text-align: center;
  padding-left: 10px;
  color: gray;
  opacity: 0.7;
  font-size: 1.5rem;
  font-family: "Roboto", sans-serif;
`;

export default FormLabelDescriptionTitle;
